import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export const initialState: DeepReadonly<SettingsState> = {
  hapticFeedback: {
    enabled: true,
  },
  enhancedBetslip: {
    enabled: true,
    touched: false,
  },
  mfa: {
    isCognitoContactSyncing: false,
  },

  // INTERNAL ONLY: remove when shipping wider PROD audience
  kambiSportsOfferingIntegrationOverride: {
    enabled: true,
  },
}

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setHapticFeedbackSetting(state, { payload }: PayloadAction<boolean>) {
      state.hapticFeedback.enabled = payload
    },
    setEnhancedBetslipSetting(state, { payload }: PayloadAction<boolean>) {
      state.enhancedBetslip.enabled = payload
      state.enhancedBetslip.touched = true
    },
    setIsCognitoContactSyncing(state, { payload }: PayloadAction<boolean>) {
      state.mfa.isCognitoContactSyncing = payload
    },
    setNewKambiSportsOfferingIntegrationSetting(state, { payload }: PayloadAction<boolean>) {
      state.kambiSportsOfferingIntegrationOverride.enabled = payload
    },
  },
})

export const {
  setHapticFeedbackSetting,
  setEnhancedBetslipSetting,
  setIsCognitoContactSyncing,
  setNewKambiSportsOfferingIntegrationSetting,
} = settingsSlice.actions

const whitelist: (keyof SettingsState)[] = [
  'hapticFeedback',
  'enhancedBetslip',
  'kambiSportsOfferingIntegrationOverride', // INTERNAL ONLY
]
export default persistReducer(
  {
    key: 'settings',
    storage,
    whitelist,
    // debug: !PRODUCTION
  },
  settingsSlice.reducer
)

// =====
// Types
// =====

export interface SettingsState {
  hapticFeedback: Setting
  enhancedBetslip: TouchedSetting
  mfa: {
    isCognitoContactSyncing: boolean
  }
  // INTERNAL ONLY
  kambiSportsOfferingIntegrationOverride: Setting
}

type Setting = { enabled: boolean }

type TouchedSetting = Setting & { touched: boolean }
